import React from "react";

const ListNoteCategory = ({ items, onEdit, onRemove }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover table-bordered">
					<thead>
						<tr>
							<th className="text-center">SN</th>
							<th>Category Name</th>
							<th className="text-center">Date created</th>
							<th className="text-center">Edit | remove</th>
						</tr>
					</thead>
					<tbody>
						{list.map((item, index) => (
							<tr key={index}>
								<td className="inbox-small-cells text-center">
									{index + 1}
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
								</td>
								<td className="view-message text-center">
									<h5>
										{Intl.DateTimeFormat("en-GB", {
											year: "numeric",
											month: "long",
											weekday: "long",
											day: "numeric"
										}).format(new Date(item.created_at))}
										{/* {item.created_at} */}
									</h5>
								</td>
								<td className="view-message text-center">
									<button
										title="Update"
										onClick={() => onEdit(item)}
										className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored btn-default"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
									<button
										title="Remove"
										onClick={() => onRemove(item)}
										className="mdl-button mdl-button--icon mdl-button--colored btn-default"
									>
										<i className="material-icons text-danger">
											remove
										</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{list.length < 1 && (
					<div className="text-center m-t-10 m-b-20">
						<h5 className="text-danger">
							No Care note category has added yet!
						</h5>
					</div>
				)}
			</div>
		</div>
	);
};

export default ListNoteCategory;
